// Jak dlouho už člen ve skupině nehrál — a jestli to vůbec stojí za řeč.
//
// „Ještě nehádá" je pravda o dnešku. U někoho, kdo je pryč šest týdnů, je to
// zamlčení: skupina čeká na člověka, který tu dávno není, a nic jí to neřekne.
//
// Práh je tu schválně. Kdyby se u každého každý den svítilo „naposledy včera",
// je z tabulky dohlížecí panel — a to je jiná hra, než jakou spolu ti lidé hrajou.
// Říká se to až od chvíle, kdy je to novinka.

export const PRAH_DNI = 7;
export const OKNO_DNI = 30;
// Od kolika dní v kuse se série ukazuje. Schválně tolik co PRAH_DNI: týden bez
// hraní na jednu stranu, týden hraní na druhou. Tabulka tím dostane dva druhy
// pozoruhodného a tichý střed mezi nimi — místo „slušní lidé a opozdilci“.
export const SERIE_DNI = 7;

const DEN = 86400000;

// Den jako UTC půlnoc. Přijímá dva tvary, protože server posílá oba:
// `last_played` je ISO den ("2026-09-12"), ale `joined_at` jde přes výchozí
// serializaci Flasku a přijde jako "Wed, 15 Jul 2026 11:54:34 GMT".
//
// Do 23. 9. 2026 se tu četlo jen ISO, takže datum vstupu vždycky vyšlo jako
// neznámé — a rozdíl mezi „nováček, který ještě nehádal" a „je pryč přes měsíc"
// tím zmizel. Nový člen se tak hned po vstupu dozvěděl, že měsíc nehraje.
// Unit test to nechytil, protože si posílal ISO, které z produkce nikdy nepřijde.
function naDatum(hodnota) {
  if (!hodnota || typeof hodnota !== "string") return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(hodnota);
  if (m) {
    const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return Number.isFinite(t) ? t : null;
  }
  const d = new Date(hodnota);
  if (isNaN(d.getTime())) return null;
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

/** Co o členovi říct. `null` znamená „nic, co by stálo za zmínku".
 *
 *  Vrací druh a počet, ne hotovou větu — překlady patří do locales a čeština si
 *  navíc žádá skloňování, které umí `pluralize`.
 *
 *  `prah` = od kolika dní se to vůbec začne říkat. Tabulka dne má sedm, správa
 *  skupiny nulu: tam se člověk dívá právě proto, aby to viděl u všech.
 */
export function lastPlayedInfo({
  lastPlayed,
  joinedAt,
  today,
  streak = 0,
  prah = PRAH_DNI,
  okno = OKNO_DNI,
  serieOd = SERIE_DNI,
}) {
  const dnes = naDatum(today);
  if (dnes === null) return null;

  // Série má přednost. Kdo hraje deset dní v kuse, o tom se nemá říkat „Hádá
  // dnes“ — to je pravda, ale ta nezajímavá.
  const n = Number(streak);
  if (Number.isFinite(n) && n >= serieOd) {
    // Delší, než kam dohlédneme. Okno je `okno` dní, takže série, která ho
    // vyplní, může být ve skutečnosti mnohem delší — „30+“ je poctivější než
    // kulaté číslo, které bychom si vymysleli.
    return { kind: "streak", days: n, capped: n >= okno };
  }

  const hral = naDatum(lastPlayed);
  if (hral !== null) {
    const dny = Math.round((dnes - hral) / DEN);
    if (dny < 0 || dny < prah) return null; // budoucnost neřešíme, čerstvost taky ne
    if (dny === 0) return { kind: "today" };
    // Včerejšek nemá vlastní druh: „Nehádá 1 den“ říká totéž a nepotřebuje k tomu
    // druhou větev ani druhý řetězec k překladu.
    return { kind: "days", days: dny };
  }

  // Nehrál v okně. Rozlišit dva velmi různé případy, které vypadají stejně:
  // kdo přišel teprve nedávno, ten „nehraje dlouho" ještě nemůže.
  const vstup = naDatum(joinedAt);
  if (vstup !== null && Math.round((dnes - vstup) / DEN) < okno) return { kind: "never" };
  return { kind: "long" };
}
